module.exports = ":host {\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pillar/common/components/action-loading.component.scss
// module id = ./src/app/pillar/common/components/action-loading.component.scss
// module chunks = main